import {trackpointMetrics} from 'lib/metricsCalculator'
import _ from 'lodash'

export const trimEnds = (troute, leftI, rightI) => {
  const {rawPoints} = troute

  const trimmed = _.slice(rawPoints, leftI, rightI + 1)
  return troute.set('rawPoints', trimmed).set('trackPoints', trackpointMetrics(trimmed))
}

export const deleteSelection = (troute, leftI, rightI) => {
  const {rawPoints} = troute

  // both rawPoints[leftI] and rawPoints[rightI] should be removed
  // _.slice(array, start, end) results in [start, end)
  const leftOfSelection = leftI > 0 ? _.slice(rawPoints, 0, leftI) : []
  const rightOfSelection = rightI < rawPoints.length ? _.slice(rawPoints, rightI + 1, rawPoints.length + 1) : []
  const withoutSelection = _.concat(leftOfSelection, rightOfSelection)
  return troute.set('rawPoints', withoutSelection).set('trackPoints', trackpointMetrics(withoutSelection))
}
